//Función Button Scroll/Slide To Top/Down
$(window).on("scroll", function () {
    if ($(window).scrollTop() >= 150) {
        if (!$("#slideToTop").is(":visible")) {
            $("#slideToTop").fadeIn(500);
        }
    } else {
        $("#slideToTop").fadeOut(500);
    }

    if ($(window).scrollTop() + $(window).height() < $('.site-footer').offset().top) {
        if (!$("#slideToBottom").is(":visible")) {
            $("#slideToBottom").fadeIn(500);
        }
    } else {
        $("#slideToBottom").fadeOut(500);
    }
});
